"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initClaimRecordInstruction = void 0;
const web3_js_1 = require("@solana/web3.js");
const api_1 = require("./api");
/**
 * Generate instruction to init claimRecord.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param param {IncentivesDistributionProgram} args.program - anchor program instance
 * @param param {PublicKey} args.treasuryAccount - treasury account
 * @param param {PublicKey} args.claimRecordAuthority - claim record account authority (claim record account is calculated from this, default: provider wallet address)
 * @param param {PublicKey} args.adminAuthority - admin authority [SIGNER] (when not provided loaded from treasuryAccount data, default: provider wallet address)
 * @param param {PublicKey} args.rentPayer [SIGNER] - rent exception payer (default: provider wallet address)
 * @type {Object} return - Return data of generated instruction
 * @return {TransactionInstruction} return.instruction - Instruction to init claimRecord
 * @return {PublicKey} return.address - created claimRecord address
 */
async function initClaimRecordInstruction({ program, treasuryAccount, claimRecordAuthority = program.provider.publicKey, adminAuthority = program.provider.publicKey, rentPayer = program.provider.publicKey, }) {
    const { address: claimRecordAccount } = (0, api_1.claimRecordAddress)({
        programId: program.programId,
        treasury: treasuryAccount,
        authority: claimRecordAuthority,
    });
    const instruction = await program.methods
        .initClaimRecord(claimRecordAuthority)
        .accountsStrict({
        treasuryAccount,
        adminAuthority,
        claimRecordAccount,
        rentPayer,
        systemProgram: web3_js_1.SystemProgram.programId,
    })
        .instruction();
    return { address: claimRecordAccount, instruction };
}
exports.initClaimRecordInstruction = initClaimRecordInstruction;
//# sourceMappingURL=initClaimRecordInstruction.js.map